import React from 'react'
import Loader from '../Loader'
import ButtonBasic from '../ButtonBasic'

const loader = <Loader quantityDots={3} sizeDots="small" isOverlay={false} title="" />
const notificationMarker = <div className="btn__notification-marker zoomIn">!</div>
const variantsWithoutSize = ['link', 'link-red', 'icon']

/**
 * Extended Button component
 * * @see ButtonBasic for behaviour options
 * * You can pass a isLoading attribute to replace the text by a loader.
 */
export function Button(props) {
  const {
    isLoading,
    variant,
    block,
    className,
    active,
    disabled,
    children,
    notify,
    focused,
    size, // big, narrow, medium
    ...otherProps
  } = props

  const variantClass = variant ? 'btn btn--' + variant : ''
  const sizeClass = variantsWithoutSize.includes(variant) || !size ? '' : 'btn--' + size

  let cssClasses = `${variantClass} ${sizeClass} ${className}`
  block && (cssClasses += ' block')
  active && (cssClasses += ' active')
  focused && (cssClasses += ' focus')
  ;(isLoading || disabled) && (cssClasses += ' disabled')
  isLoading && (cssClasses += ' btn--loading')

  return (
    <ButtonBasic {...otherProps} className={cssClasses} disabled={disabled || isLoading}>
      {isLoading && loader}
      {isLoading ? <div style={{ visibility: 'hidden' }}>{children}</div> : children}
      {notify && notificationMarker}
    </ButtonBasic>
  )
}

Button.defaultProps = {
  className: '',
  isLoading: false,
  block: false,
  notify: false,
  size: 'medium',
}

export default React.memo(Button)
